<script lang="ts">
  export let light: boolean = false;
  export let ml: boolean = false; // margin-left
  export let mr: boolean = false; // margin-right

  // Build the full class string dynamically
  $: spinnerClass = ['loading-spinner', light && 'loading-spinner--light', ml && 'loading-spinner--ml', mr && 'loading-spinner--mr'].filter(Boolean).join(' ');
</script>

<span class={spinnerClass} aria-hidden="true" />
